import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {Configuration} from '../../../services/configuration'

@Component({
  selector: 'spb-save-button',
  imports: [
    MatButton
  ],
  templateUrl: './save-button.html'
})
export class SaveButton {
  public service = inject(Configuration)
}
